import { COLLECTIONS } from "constants/action-types";
import { FluxStandardAction as Action } from "flux-standard-action";
import {
    AllocationBagType,
    BagValues,
    ICreateAllocationDimensionValue,
    IUpdateAllocationDimensionValue,
} from "helpers/allocation-dimension";

export type MoveAllocationDimensionValueAction = Action<
    {
        allocationDimensionId: string;
        index: number;
        destinationIndex: number;
        rowId: string;
    },
    | {
          history?: boolean;
      }
    | undefined
>;
export const moveAllocationDimensionValue = (
    allocationDimensionId: string,
    index: number,
    destinationIndex: number,
    rowId: string,
    meta?
): MoveAllocationDimensionValueAction => ({
    payload: {
        allocationDimensionId,
        index,
        destinationIndex,
        rowId,
    },
    meta,
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.VALUE.MOVE.START,
});

export type BulkMutateAllocationDimensionValuesAction = Action<
    {
        allocationDimensionId: string;
        items: Array<ICreateAllocationDimensionValue | IUpdateAllocationDimensionValue>;
    },
    | {
          history?: boolean;
      }
    | undefined
>;
export const bulkMutateAllocationDimensionValues = (
    allocationDimensionId: string,
    items: Array<ICreateAllocationDimensionValue | IUpdateAllocationDimensionValue>,
    meta?
): BulkMutateAllocationDimensionValuesAction => ({
    payload: {
        allocationDimensionId,
        items,
    },
    meta,
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.VALUE.BULK_MUTATE.START,
});

export interface IMutateAllocationBagValue {
    bagType: AllocationBagType;
    rowId: string;
    dimensionValues: string[];
    quantity: number;
}
export const mutateAllocationBag = (collectionId: string, value: IMutateAllocationBagValue) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.BAG_VALUE.MUTATE,
    payload: { collectionId, value },
});

export const bulkMutateAllocationBag = (collectionId: string, values: IMutateAllocationBagValue[]) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.BAG_VALUE.BULK_MUTATE,
    payload: { collectionId, values },
});

export const replaceBagValues = (
    collectionId: string,
    bagType: AllocationBagType,
    rowId: string,
    bagValues: BagValues
) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.BAG_VALUE.REPLACE_BAG_VALUES,
    payload: { collectionId, bagType, bagValues, rowId },
});

export const clearAllocationBag = (collectionId: string, bagType: AllocationBagType, itemId: string) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.BAG_VALUE.CLEAR,
    payload: { collectionId, itemId, bagType },
});

export const bulkClearAllocationBag = (itemIds: string[], bagTypes: AllocationBagType[]) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.BAG_VALUE.BULK_CLEAR,
    payload: { itemIds, bagTypes },
});
